export default __webpack_public_path__ + "static/symbox-logo-f4b0d4b0d80e9d8e9d2f8b9417a88b57.png";